import type { Locale, ProcessingStage } from '../types';

export const messages = {
  es: {
    tagline: 'Subtítulos para cualquier video.',
    subtitle: 'Privados, locales y listos para descargar.',
    privacy: 'Tu video se procesa en este dispositivo. No se sube a nuestros servidores.',
    dropTitle: 'Arrastra un video o audio aquí',
    dropHint: 'MP4, WebM, MOV, M4V, MKV y audio común',
    select: 'Seleccionar archivo',
    language: 'Idioma hablado',
    output: 'Subtítulos',
    quality: 'Calidad',
    automatic: 'Automático',
    spanish: 'Español',
    english: 'Inglés',
    original: 'Idioma original',
    bilingual: 'Bilingüe',
    generate: 'Generar subtítulos',
    cancel: 'Cancelar procesamiento',
    download: 'Descargar .SRT',
    another: 'Procesar otro',
    retryTranslation: 'Reintentar traducción',
    preview: 'Vista previa editable',
    ready: 'Subtítulos generados',
    battery: 'Procesar videos largos puede consumir bastante batería.',
    models: 'Modelos descargados',
    clearModels: 'Liberar modelos',
    noCachedModels: 'Aún no hay modelos en caché.',
    theme: 'Tema',
    locale: 'Idioma de la interfaz',
    advanced: 'Opciones avanzadas',
    firstDownload:
      'La primera ejecución descarga los modelos. Después quedan disponibles en caché.',
    fileWarning:
      'Este archivo es grande para este dispositivo. Puedes intentarlo, pero el navegador podría quedarse sin memoria.',
    stages: {
      idle: '',
      preparing: 'Preparando archivo',
      extracting: 'Extrayendo audio',
      'loading-transcription': 'Cargando modelo de transcripción',
      transcribing: 'Transcribiendo',
      'loading-translation': 'Cargando modelo de traducción',
      translating: 'Traduciendo',
      generating: 'Generando subtítulos',
      complete: 'Listo',
      cancelled: 'Procesamiento cancelado',
      error: 'No se pudo completar',
    } satisfies Record<ProcessingStage, string>,
  },
  en: {
    tagline: 'Subtitles for any video.',
    subtitle: 'Private, local, and ready to download.',
    privacy: 'Your video is processed on this device. It is not uploaded to our servers.',
    dropTitle: 'Drop a video or audio file here',
    dropHint: 'MP4, WebM, MOV, M4V, MKV, and common audio formats',
    select: 'Choose file',
    language: 'Spoken language',
    output: 'Subtitles',
    quality: 'Quality',
    automatic: 'Automatic',
    spanish: 'Spanish',
    english: 'English',
    original: 'Original language',
    bilingual: 'Bilingual',
    generate: 'Generate subtitles',
    cancel: 'Cancel processing',
    download: 'Download .SRT',
    another: 'Process another',
    retryTranslation: 'Retry translation',
    preview: 'Editable preview',
    ready: 'Subtitles generated',
    battery: 'Processing long videos can use significant battery.',
    models: 'Downloaded models',
    clearModels: 'Remove models',
    noCachedModels: 'No models are cached yet.',
    theme: 'Theme',
    locale: 'Interface language',
    advanced: 'Advanced options',
    firstDownload: 'The first run downloads the models. They are cached for later use.',
    fileWarning:
      'This file is large for this device. You can try it, but the browser may run out of memory.',
    stages: {
      idle: '',
      preparing: 'Preparing file',
      extracting: 'Extracting audio',
      'loading-transcription': 'Loading transcription model',
      transcribing: 'Transcribing',
      'loading-translation': 'Loading translation model',
      translating: 'Translating',
      generating: 'Generating subtitles',
      complete: 'Ready',
      cancelled: 'Processing cancelled',
      error: 'Could not finish',
    } satisfies Record<ProcessingStage, string>,
  },
} as const satisfies Record<Locale, object>;
